import { render, staticRenderFns } from "./itemSocialSharing.vue?vue&type=template&id=1ec7c43a"
import script from "./itemSocialSharing.vue?vue&type=script&lang=ts"
export * from "./itemSocialSharing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports